import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

export class GooglePayStore extends BaseStore {
    getInitialState() {
        return super.getInitialState().merge({
            clientToken: null,
            loading: false,
            error: null,
        });
    }

    handleTokenLoading() {
        this.setState(this.state.set('loading', true).set('error', null));
    }

    handleTokenLoaded({ token }) {
        this.setState(this.state.set('clientToken', token).set('loading', false).set('error', null));
    }

    handleTokenError({ error }) {
        this.setState(this.state.set('loading', false).set('error', error));
    }

    getClientToken() {
        return this.get('clientToken');
    }

    getLoading() {
        return this.get('loading');
    }

    getError() {
        return this.get('error');
    }

    getActionHandlers() {
        return {
            [ActionTypes.GOOGLE_PAY_CLIENT_TOKEN_LOADING]: this.handleTokenLoading,
            [ActionTypes.GOOGLE_PAY_CLIENT_TOKEN_LOADED]: this.handleTokenLoaded,
            [ActionTypes.GOOGLE_PAY_CLIENT_TOKEN_ERROR]: this.handleTokenError,
            [ActionTypes.LOGGED_OUT]: this.resetState
        };
    }
}

const instance = new GooglePayStore();

export default instance;
